const useDeployedApi = true;

export const base_url = useDeployedApi
  ? "https://us-central1-pay-the-dragon-7b77d.cloudfunctions.net/api"
  : "http://127.0.0.1:5001/pay-the-dragon-7b77d/us-central1/api";
